import "./OurExpertise.module.css";
import Header from "@/reusable_sections/Header";
import OurMethodology from "./sections/OurMethodology";
import BrandedCampaigns from "./sections/BrandedCampaigns";
import AgedLeadsSolutions from "./sections/AgedLeadsSolutions";
import Footer from "@/reusable_sections/Footer";
export default function OurExpertisePage() {
  return <div>
      <Header />
      <OurMethodology />
      <BrandedCampaigns />
      <AgedLeadsSolutions />
      <Footer />
    </div>;
}